import React from 'react';
import { CheckCircle2, Shield, UserCheck, LockKeyhole } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';
export const AppLoading = () => {
	return (
		<div className="flex flex-col items-center justify-center h-screen p-6 bg-background text-foreground max-md:h-app max-md:pb-[max(1.5rem,var(--safe-bottom))] max-md:pt-[max(1.5rem,var(--safe-top))]">
			<div className="w-full max-w-md flex flex-col items-center gap-8">
				{/* Logo placeholder with colorful ring */}
				<div className="relative mb-2 group">
					<div className="absolute inset-0 rounded-full bg-gradient-to-r from-cyan-500 via-blue-500 to-purple-500 blur-md animate-pulse" />
					<Skeleton className="relative h-24 w-24 rounded-full bg-background flex items-center justify-center overflow-hidden">
						{/* Subtle shine effect */}
						<div className="absolute inset-0 animate-shine bg-gradient-to-r from-transparent via-white/10 to-transparent" />
						{/* Custom checkmark SVG with rounded edges */}
						<svg
							width="64"
							height="64"
							viewBox="0 0 64 64"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							className="opacity-80 relative z-10"
						>
							<path
								d="M18 32L26 40L46 20"
								stroke="url(#gradient-checkmark)"
								strokeWidth="5"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<defs>
								<linearGradient
									id="gradient-checkmark"
									x1="18"
									y1="32"
									x2="46"
									y2="20"
									gradientUnits="userSpaceOnUse"
								>
									<stop stopColor="#06b6d4" />
									<stop offset="0.5" stopColor="#3b82f6" />
									<stop offset="1" stopColor="#a855f7" />
								</linearGradient>
							</defs>
						</svg>
					</Skeleton>
				</div>

				<p className="text-2xl text-muted-foreground mt-6 text-center animate-pulse max-md:text-xl">
					Preparing your workspace...
				</p>

				<div className="w-full space-y-4">
					{/* Loading steps with animations and colors */}
					<div className="flex items-center gap-3">
						<div className="flex items-center justify-center bg-blue-500/20 rounded-full p-2">
							<CheckCircle2 className="size-5 text-blue-500 animate-pulse" />
						</div>
						<div className="flex-1">
							<Skeleton className="h-4 w-full bg-blue-500/10 animate-pulse" />
						</div>
					</div>

					<div className="flex items-center gap-3">
						<div className="flex items-center justify-center bg-purple-500/20 rounded-full p-2">
							<Shield className="size-5 text-purple-500 animate-pulse delay-100" />
						</div>
						<div className="flex-1">
							<Skeleton className="h-4 w-4/5 bg-purple-500/10 animate-pulse delay-100" />
						</div>
					</div>

					<div className="flex items-center gap-3">
						<div className="flex items-center justify-center bg-emerald-500/20 rounded-full p-2">
							<UserCheck className="size-5 text-emerald-500 animate-pulse delay-200" />
						</div>
						<div className="flex-1">
							<Skeleton className="h-4 w-3/5 bg-emerald-500/10 animate-pulse delay-200" />
						</div>
					</div>

					<div className="flex items-center gap-3">
						<div className="flex items-center justify-center bg-amber-500/20 rounded-full p-2">
							<LockKeyhole className="size-5 text-amber-500 animate-pulse delay-300" />
						</div>
						<div className="flex-1">
							<Skeleton className="h-4 w-2/5 bg-amber-500/10 animate-pulse delay-300" />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
